var _style, _path, _path2, _path3, _path4, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#689F63;}\n\t.st1{fill:#404137;}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000069355823376730521740000006194380185994148528_);fill:url(#SVGID_00000156565823321458892450000003928491665305858238_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000137116260478061446540000005965597124610580384_);fill:url(#SVGID_00000162353322297907481160000015793671867927203238_);}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000058576007213279827910000003749172896097375415_);fill:url(#SVGID_00000046327914028956566780000007134176888826429078_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M253.03,412.87c-1.68,0-3.37-0.42-4.91-1.26l-15.43-9.12c-2.25-1.26-1.12-1.68-0.42-1.96 c3.09-1.12,3.65-1.26,7.02-3.23c0.28-0.14,0.84-0.14,1.12,0.14l11.93,7.02c0.42,0.28,0.98,0.28,1.4,0l46.3-26.66 c0.42-0.28,0.7-0.7,0.7-1.26v-53.32c0-0.56-0.28-0.98-0.7-1.26l-46.16-26.66c-0.42-0.28-0.98-0.28-1.4,0l-46.16,26.66 c-0.42,0.28-0.7,0.7-0.7,1.26v53.32c0,0.56,0.28,0.98,0.7,1.26l12.63,7.3c6.88,3.51,11.08-0.56,11.08-4.63v-52.9 c0-0.7,0.56-1.26,1.4-1.26h5.89c0.7,0,1.26,0.56,1.26,1.26v52.76c0,9.12-5.05,14.45-13.75,14.45c-2.67,0-4.77,0-10.66-2.95 l-12.07-7.02c-2.95-1.68-4.91-4.91-4.91-8.42v-53.32c0-3.51,1.82-6.73,4.91-8.42l46.3-26.66c2.95-1.68,6.88-1.68,9.68,0l46.3,26.66 c2.95,1.68,4.91,4.91,4.91,8.42v53.32c0,3.51-1.82,6.73-4.91,8.42l-46.3,26.66C256.4,412.31,254.72,412.87,253.03,412.87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M267.35,376.11c-20.2,0-24.41-9.26-24.41-17.12c0-0.7,0.56-1.26,1.4-1.26h6.03 c0.7,0,1.26,0.42,1.26,1.12c0.84,6.03,3.65,9.12,15.86,9.12c9.68,0,13.89-2.25,13.89-7.44c0-2.95-1.12-5.19-16.28-6.73 c-12.63-1.26-20.49-4.07-20.49-14.17c0-9.4,7.86-14.87,21.05-14.87c14.87,0,22.17,5.19,23.01,16.14c0,0.42-0.14,0.7-0.42,0.98 c-0.28,0.28-0.56,0.42-0.98,0.42h-6.03c-0.56,0-1.12-0.42-1.26-0.98c-1.4-6.45-4.91-8.42-14.45-8.42 c-10.66,0-11.93,3.65-11.93,6.45c0,3.37,1.4,4.35,15.86,6.31c14.17,1.82,20.91,4.49,20.91,14.59 C290.36,370.35,281.94,376.11,267.35,376.11 M323.61,319.56h1.54c1.26,0,1.54-0.84,1.54-1.4c0-1.4-0.98-1.4-1.4-1.4h-1.54 L323.61,319.56z M321.65,315.07h3.51c1.12,0,3.51,0,3.51,2.67c0,1.82-1.12,2.25-1.82,2.39c1.4,0.14,1.4,0.98,1.68,2.24 c0.14,0.84,0.28,2.24,0.56,2.67h-2.1c0-0.42-0.42-2.95-0.42-3.09c-0.14-0.56-0.28-0.84-0.98-0.84h-1.68v4.07h-1.96v-10.1H321.65z  M317.58,320.12c0,4.21,3.37,7.44,7.44,7.44c4.21,0,7.44-3.37,7.44-7.44c0-4.21-3.37-7.44-7.44-7.44 C320.94,312.69,317.58,315.91,317.58,320.12 M333.99,320.12c0,4.91-4.07,8.98-8.98,8.98c-4.91,0-8.98-3.93-8.98-8.98 c0-5.05,4.21-8.98,8.98-8.98C329.78,311.28,333.99,315.07,333.99,320.12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st1",
    d: "M109.77,203.94c0-2.1-1.12-4.07-2.95-5.19l-48.97-28.2c-0.84-0.42-1.82-0.7-2.67-0.84h-0.56 c-0.98,0-1.82,0.28-2.67,0.84L3,198.75c-1.82,1.12-2.95,3.09-2.95,5.19l0.14,76.05c0,1.12,0.56,2.1,1.4,2.53 c0.84,0.56,2.1,0.56,2.95,0l29.04-16.7c1.82-1.12,2.95-3.09,2.95-5.19v-35.5c0-2.1,1.12-4.07,2.95-5.19l12.35-7.16 c0.98-0.56,1.96-0.84,2.95-0.84s2.1,0.28,2.95,0.84l12.35,7.16c1.82,1.12,2.95,2.95,2.95,5.19v35.5c0,2.1,1.12,4.07,2.95,5.19 l29.18,16.7c0.98,0.56,2.1,0.56,2.95,0c0.84-0.56,1.4-1.54,1.4-2.53L109.77,203.94z M341.15,243.51c0,0.56-0.28,0.98-0.7,1.26 l-16.84,9.68c-0.42,0.28-0.98,0.28-1.54,0l-16.84-9.68c-0.42-0.28-0.7-0.7-0.7-1.26v-19.5c0-0.56,0.28-0.98,0.7-1.26l16.84-9.68 c0.42-0.28,0.98-0.28,1.54,0l16.84,9.68c0.42,0.28,0.7,0.7,0.7,1.26V243.51z M345.78,99.55c-0.98-0.56-2.1-0.56-2.95,0 s-1.4,1.54-1.4,2.53v75.35c0,0.7-0.42,1.4-0.98,1.82c-0.7,0.42-1.4,0.42-2.1,0L326,172.23c-1.82-1.12-4.07-1.12-5.89,0 l-49.11,28.34c-1.82,1.12-2.95,2.95-2.95,5.05v56.69c0,2.1,1.12,4.07,2.95,5.19l49.11,28.34c1.82,1.12,4.07,1.12,5.89,0 l49.11-28.34c1.82-1.12,2.95-2.95,2.95-5.19V121.02c0-2.1-1.12-4.07-3.09-5.19L345.78,99.55z M509.1,223.59 c1.82-1.12,2.95-2.95,2.95-5.05v-13.75c0-2.1-1.12-4.07-2.95-5.19l-48.69-28.34c-1.82-1.12-4.07-1.12-5.89,0l-49.11,28.34 c-1.82,1.12-2.95,2.95-2.95,5.19v56.55c0,2.1,1.12,4.07,2.95,5.19l48.69,27.78c1.82,0.98,3.93,0.98,5.75,0l29.47-16.42 c0.98-0.56,1.54-1.54,1.54-2.53c0-1.12-0.56-2.1-1.54-2.53l-49.39-28.34c-0.98-0.56-1.54-1.54-1.54-2.53v-17.82 c0-1.12,0.56-2.1,1.54-2.53l15.29-8.84c0.98-0.56,2.1-0.56,2.95,0l15.29,8.84c0.98,0.56,1.54,1.54,1.54,2.53v14.03 c0,1.12,0.56,2.1,1.54,2.53c0.98,0.56,2.1,0.56,2.95,0L509.1,223.59z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st0",
    d: "M456.63,220.92c0.28-0.14,0.84-0.14,1.12,0l9.4,5.47c0.42,0.14,0.56,0.56,0.56,0.98v10.8 c0,0.42-0.28,0.84-0.56,0.98l-9.4,5.47c-0.42,0.14-0.84,0.14-1.12,0l-9.4-5.47c-0.42-0.14-0.56-0.56-0.56-0.98v-10.8 c0-0.42,0.14-0.84,0.56-0.98L456.63,220.92z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M185.96,171.67l-48.83,28.2c-1.82,1.12-2.95,2.95-2.95,5.05v56.41c0,2.1,1.12,4.07,2.95,5.05l48.83,28.2 c1.82,0.98,4.07,0.98,5.89,0l48.83-28.2c1.82-1.12,2.95-2.95,2.95-5.05v-56.41c0-2.1-1.12-4.07-2.95-5.05l-48.83-28.2 c-0.98-0.56-1.96-0.84-2.95-0.84S186.95,171.11,185.96,171.67"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165936864423636994650000006088876481334603650_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159439491829434014280000013658752062005157052_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.2666,
    y1: 505.9374,
    x2: 7.1353,
    y2: 505.9374,
    gradientTransform: "matrix(-81.162 165.5699 165.5699 81.162 -83035.2344 -41939.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E863D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#3E863D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#55934F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#5AAD45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5AAD45"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000165936864423636994650000006088876481334603650_)",
      fill: "url(#SVGID_00000159439491829434014280000013658752062005157052_)"
    },
    points: " 292.88,194.96 155.38,127.61 84.94,271.43 222.45,338.78  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000009564030723964076880000013940521776959632512_",
    d: "M135.45,264.84c0.42,0.56,0.98,1.12,1.68,1.54 l41.81,24.13l7.02,4.07c0.98,0.56,2.25,0.84,3.37,0.7c0.42,0,0.84-0.14,1.12-0.28l51.49-94.15c-0.42-0.42-0.84-0.84-1.4-1.12 l-31.99-18.38l-16.84-9.68c-0.42-0.28-0.98-0.42-1.54-0.56L135.45,264.84z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126325432335670011400000012370551057622813352_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009564030723964076880000013940521776959632512_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145766840868520982600000017523024596018480513_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.8621,
    y1: 505.9582,
    x2: 6.7304,
    y2: 505.9582,
    gradientTransform: "matrix(147.809 -109.2133 -109.2133 -147.809 54515.457 75705.9922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E863D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#3E863D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#619857"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AC64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000126325432335670011400000012370551057622813352_)",
      fill: "url(#SVGID_00000145766840868520982600000017523024596018480513_)"
    },
    points: " 76.1,214.89 173.06,346.22 301.44,251.51 204.34,120.04  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000020362841675379294390000008432494462359588010_",
    d: "M188.35,170.83c-0.84,0.14-1.68,0.28-2.39,0.7 l-48.69,28.06l52.48,95.55c0.7-0.14,1.4-0.28,2.1-0.7l48.83-28.2c1.54-0.84,2.53-2.39,2.81-4.07l-53.46-91.2 c-0.42-0.14-0.84-0.14-1.12-0.14C188.63,170.83,188.49,170.83,188.35,170.83"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006672566818771213260000010607772570531590075_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020362841675379294390000008432494462359588010_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031189806858765299530000000292066690301689516_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.8517,
    y1: 505.7708,
    x2: 6.7194,
    y2: 505.7708,
    gradientTransform: "matrix(122.2438 0 0 -122.2438 -577.9164 62060.3242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BBF47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#6BBF47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#79B461"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#75AC64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#659E5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#3E863D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E863D"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 137.42,
    y: 170.83,
    style: {
      clipPath: "url(#SVGID_00000006672566818771213260000010607772570531590075_)",
      fill: "url(#SVGID_00000031189806858765299530000000292066690301689516_)"
    },
    width: 106.08,
    height: 124.32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.8361c04a47563ead51211f5f3e998a51.svg";
export { ForwardRef as ReactComponent };